import React from 'react';
import { FaEdit } from 'react-icons/fa';

function JudgeTableRow({index, fname, lname, email, phone, admin, ballots, onEdit}) {
  return (
    <tr>
      <td className='Table bg-slate-200'>{index + 1}</td>
      <td className='Table bg-slate-200'>{fname+ " " +lname}</td>
      <td className='Table bg-slate-200'>{phone}</td>
      <td className='Table bg-slate-200'>{email}</td>
      <td className='Table bg-slate-200'>{admin ? 'Yes' : 'No'}</td>
      <td className='Table bg-slate-200'>{ballots}</td>
      <td className='Table bg-slate-200'>
        <button onClick={onEdit} className='flex text-md gap-2'>
          Edit <FaEdit className='pt-1' />
        </button>
      </td>
    </tr>
  );
}

export default JudgeTableRow;
